const FooterBottom = () => {
  return (
    <div className='w-full py-10'>
      <p className='text-center text-gray-500 text-base'>
        {' '}
        <span>&#169;</span> 2025. All Rights reserved by Victor Leo Okeke{' '}
      </p>
    </div>
  );
};
export default FooterBottom;
